<template>
  <div class="resources-mobile">
    <div class="box">
      <p class="title" id="News">{{$t('resources.news')}}</p>
      <p class="des">{{$t('resources.des1')}}</p>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article0">
            <img src="../assets/resources-web/0.png" />
            <p class="content">{{$t('article0.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article1">
            <img src="../assets/resources-mobile/1 手机.png" />
            <p class="content">{{$t('article1.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article2">
            <img src="../assets/resources-mobile/2手机.png" />
            <p class="content">{{$t('article2.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article3">
            <img src="../assets/resources-mobile/3手机.png" />
            <p class="content">{{$t('article3.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article4">
            <img src="../assets/resources-mobile/4手机.png" />
            <p class="content">{{$t('article4.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article5">
            <img src="../assets/resources-mobile/5手机.png" />
            <p class="content">{{$t('article5.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article6">
            <img src="../assets/resources-mobile/6手机.png" />
            <p class="content">{{$t('article6.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article7">
            <img src="../assets/resources-mobile/7手机.png" />
            <p class="content">{{$t('article7.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article8">
            <img src="../assets/resources-mobile/8手机.png" />
            <p class="content">{{$t('article8.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article17">
            <img src="../assets/resources-mobile/17手机.png" />
            <p class="content">{{$t('article17.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article18">
            <img src="../assets/article/18 RedteaGO Global eSIM Plan _m.png" />
            <p class="content">{{$t('article18.title')}}</p>
          </router-link>
        </Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Industry">{{$t('resources.report')}}</p>
      <p class="des">{{$t('resources.des2')}}</p>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article9">
            <img src="../assets/resources-mobile/9手机.png" />
            <p class="content">{{$t('article9.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article10">
            <img src="../assets/resources-mobile/10手机.png" />
            <p class="content">{{$t('article10.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article11">
            <img src="../assets/resources-mobile/11手机.png" />
            <p class="content">{{$t('article11.title')}}</p>
          </router-link>
        </Col>
        <Col span="12"></Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Insights">{{$t('resources.Insights')}}</p>
      <p class="des">{{$t('resources.des3')}}</p>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article12">
            <img src="../assets/resources-mobile/12手机.png" />
            <p class="content">{{$t('article12.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article13">
            <img src="../assets/resources-mobile/13手机.png" />
            <p class="content">{{$t('article13.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article14">
            <img src="../assets/resources-mobile/14手机.png" />
            <p class="content">{{$t('article14.title')}}</p>
          </router-link>
        </Col>
        <Col span="12" style="text-align:left;padding-left:0.15rem;">
          <router-link target="_blank" to="article15">
            <img src="../assets/resources-mobile/15手机.png" />
            <p class="content">{{$t('article15.title')}}</p>
          </router-link>
        </Col>
      </Row>
      <Row>
        <Col span="12" style="text-align:left;">
          <router-link target="_blank" to="article16">
            <img src="../assets/resources-mobile/16手机.png" />
            <p class="content">{{$t('article16.title')}}</p>
          </router-link>
        </Col>
        <Col span="12"></Col>
      </Row>
    </div>

    <div class="box">
      <p class="title" id="Terms">{{$t('resources.terms')}}</p>
      <p class="des">{{$t('resources.des4')}}</p>
      <div style="display:flex;justify-content:center;align-items:center;margin-top:0.2rem;">
        <img src="../assets/resources-mobile/下载.svg" style="width:0.15rem;margin:0 0.1rem 0 0;" />
        <span class="content" style="font-size:0.14rem;">{{$t('resources.download')}}</span>
      </div>
    </div>

    <div class="box">
      <p class="title" id="FAQ">{{$t('resources.FAQ')}}</p>
      <p class="des">{{$t('resources.FAQdes')}}</p>
      <div style="display:flex;justify-content:center;align-items:center;margin-top:0.2rem;">
        <img src="../assets/resources-mobile/下载.svg" style="width:0.15rem;margin:0 0.1rem 0 0;" />
        <span class="content" style="font-size:0.14rem;">{{$t('resources.download')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resources-mobile',
  components: {}
}
</script>
<style lang="less" scoped>
.resources-mobile {
  padding-top: 1.2rem;
  .box {
    padding: 0 0.2rem 0.4rem 0.2rem;
  }
  .title {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-Regular';
    font-size: 0.16rem;
    margin-bottom: 0.2rem;
  }
  .des {
    color: rgba(32, 49, 82, 0.8);
    font-family: 'Poppins-ExtraLight';
    font-size: 0.12rem;
    text-align: left;
  }
  .content {
    color: rgba(32, 49, 82, 1);
    font-family: 'Poppins-ExtraLight';
    font-size: 0.12rem;
    text-align: left;
  }
  img {
    width: 1.52rem;
    margin-top: 0.18rem;
    margin-bottom: 0.1rem;
    text-align: left;
  }
}
</style>
